import React from 'react';

import commentIcon from 'app/static/icons/comment-icon.svg';

import { Trans } from 'react-i18next';
import moment from 'moment';
import { VisualFlowIcon } from 'generated/request-backend';

// function VisualFlowStep(props: any) {
function VisualFlowStep({
    key,
    id,
    title,
    lastActivity,
    date,
    age,
    status,
    attachmentCount,
    triggerShowComments,
    hideComments,
    showComment,
    width,
    getIcon,
    icon,
    commentCount
}: {
    key: number,
    id: number,
    title: string,
    lastActivity: Date,
    date: Date,
    age: string,
    status: string,
    attachmentCount: number,
    triggerShowComments: (e: React.MouseEvent, id: number) => void,
    hideComments: (e: React.MouseEvent, id: number) => void,
    showComment: boolean,
    width: string,
    getIcon: (icon: VisualFlowIcon) => JSX.Element,
    icon: VisualFlowIcon,
    commentCount: number
}) {
    return (
        <div className={`step step-${id} ${status}`} style={{ minWidth: width }}>
            <div className="step-details">
                <div className="number">{id}</div>
                <div
                    className="details"
                    onMouseEnter={(e: React.MouseEvent) => triggerShowComments(e, id)}
                    onMouseLeave={(e: React.MouseEvent) => hideComments(e, id)}>
                    <div className="title">{title}</div>

                    <div className="last-activity">
                        <Trans>Last Activity</Trans>: {moment(lastActivity).format('hh:mm a')}
                    </div>
                    <div className="custom-row">
                        <div className="messages">
                            <img className="comment-icon" src={commentIcon} alt="comment" />
                            {commentCount}
                        </div>
                    </div>
                </div>
            </div>
            <div className="verticle-dashed-line"></div>
            <div className="step-icon">
                <div className="step-icon__border">
                    <div className="step-icon__bg">{getIcon(icon)}</div>
                </div>
            </div>
            <div className="step-date-aging">
                <div className="date">{moment(date).format('MMM DD yyyy')}</div>
                <div className={`badge--status ${status}`}>{age}</div>
            </div>
            <span className="arrow"></span>
        </div>
    );
}

export default VisualFlowStep;
